module.exports = __webpack_public_path__ + "img/download_android_text.719976d7.png";